// removed by extract-text-webpack-plugin
module.exports = {"base":"Header_base--29x8-","title":"Header_title--2Prl4","paginator":"Header_paginator--3BpRN","paginator__hidden":"Header_paginator__hidden--3GFSi","paginatorHidden":"Header_paginator__hidden--3GFSi"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/components/Header/Header.scss
// module id = 2323
// module chunks = 11